<template>
  <v-dialog v-model="trigger" max-width="768">
    <v-card>
      <v-card-title class="text-h5 primary white--text">
        {{
          family == null
            ? "Agregar nueva familia"
            : "Editar " + family.attributes.nombre
        }}
        <v-spacer></v-spacer>
        <v-btn @click="emitCancel" class="white--text" icon outlined>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <v-container fluid class="mt-4">
          <v-form ref="form" v-model="valid">
            <v-row>
              <v-col cols="12" md="12">
                <v-text-field
                  v-model="familyData.nombre"
                  :rules="[required]"
                  dense
                >
                  <template #label>
                    <span>Nombre<strong class="red--text"> *</strong></span>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="emitCancel">
          <v-icon>mdi-close-circle-outline</v-icon>Cancelar
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="accent" :disabled="!valid" @click="emitDataEntered">
          <v-icon>{{ family == null ? "mdi-plus" : "mdi-pencil" }}</v-icon
          >{{ family == null ? "Agregar" : "Editar" }}
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { required } from "@/helpers/formHelpers";

export default {
  props: {
    family: Object,
    trigger: Boolean,
  },
  data() {
    return {
      valid: false,
      required,
    };
  },
  computed: {
    familyData: {
      get() {
        return {
          id: this.family != null ? this.family.id : null,
          nombre: this.family != null ? this.family.attributes.nombre : null,
        };
      },
    },
  },
  methods: {
    emitDataEntered() {
      if (this.family == null) {
        this.$emit("onAddRequest", this.familyData);
        return;
      }
      this.$emit("onEditRequest", this.familyData);
    },
    emitCancel() {
      this.$emit("onCancel");
    },
  },
};
</script>